module.exports = __webpack_public_path__ + "img/pyöräilyreitti_original.4d49691a.png";